module.exports = require("@aws-sdk/client-sesv2");